// hooks/useCurrentUser.js
import { useState, useEffect } from 'react';
import { fetchCurrentUserApi } from '../services/api';

export const useCurrentUser = (userId, apiUrl) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return;
      try {
        const user = await fetchCurrentUserApi(userId, apiUrl);
        setCurrentUser(user);
      } catch (error) {
        console.error("Error fetching current user:", error);
      }
    };
    fetchUser();
  }, [userId, apiUrl]);

  return { currentUser };
};